/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConversationThreadContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "LocalReplyListContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "ConversationThreadContainer_viewer";
};
export type ConversationThreadContainer_viewer$data = ConversationThreadContainer_viewer;
export type ConversationThreadContainer_viewer$key = {
    readonly " $data"?: ConversationThreadContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationThreadContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LocalReplyListContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '93d5cdedb86824509fec9f21b0c6ec32';
export default node;
